import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import TextArea from '../../../common/textarea';
import Modal from '../../../common/Modal';
import CurrencyInput from '../../../common/currencyInput';
import Money from '../../../common/money';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import CountBillsTable from './CountBillsTable';


const CloseRegister = ({
  modalOn,
  modalOff,
  modalIsOn,
  handleSubmit,
  expectedBalance,
  actualEndBalance,
  cashSales,
  paidOut,
  paidIn,
  openedAt,
  openedBy,
  showCountBillsToggle,
  countBills,
}) => (
  <div className="u-inline-block">
    <button className="c-btn c-btn--medium c-btn--red" onClick={modalOn}>
      Close Register
    </button>
    <Modal title="Close cash register" close={modalOff} display-if={modalIsOn}>
      <form onSubmit={handleSubmit}>
        <div className="u-ph+ u-pt+">
          <CheckboxSwitch
            display-if={showCountBillsToggle}
            name="countBills"
            id="countBills"
            label="Count Bills"
            labelOnTheRight
            wrapperClass="u-text-right u-mb"
          />
          <FieldArray
            name="billCounts"
            component={CountBillsTable}
            display-if={countBills}
          />
          <div className="o-flexbox u-mb">
            <div className="u-inline-block">
              <div className="c-label u-inline-block u-mr u-mb-">Expected in Drawer</div>
              <div className="c-heading-small dark-mode-white">
                <Money>{expectedBalance}</Money>
              </div>
            </div>
            <div className="u-inline-block">
              <label className="c-label u-inline-block" htmlFor="actualEndBalance">Actual Balance</label>
              <CurrencyInput
                className="c-input c-input--white"
                name="actualEndBalance"
                display-if={!countBills}
              />
              <div className="c-heading-small dark-mode-white" display-if={countBills}>
                <Money>{actualEndBalance}</Money>
              </div>
            </div>
          </div>
          <div className="u-mb">
            <div className="c-label">Description</div>
            <TextArea
              className="c-textarea"
              type="text"
              placeholder="Add note"
              name="notes"
              rows="2"
            />
          </div>
          <div className="c-table c-table-new c-table--small c-no-hover">
            <div className="c-table-card__row">
              <div className="c-table-card__cell">Started</div>
              <div className="c-table-card__cell u-text-right">
                {openedAt}
              </div>
            </div>
            <div className="c-table-card__row">
              <div className="c-table-card__cell">Started By</div>
              <div className="c-table-card__cell u-text-right">
                {openedBy}
              </div>
            </div>
            <div className="c-table-card__row">
              <div className="c-table-card__cell">Paid Out</div>
              <div className="c-table-card__cell u-text-right">
                <Money>{paidOut}</Money>
              </div>
            </div>
            <div className="c-table-card__row">
              <div className="c-table-card__cell">Paid In</div>
              <div className="c-table-card__cell u-text-right">
                <Money>{paidIn}</Money>
              </div>
            </div>
            <div className="c-table-card__row">
              <div className="c-table-card__cell">Cash Sales</div>
              <div className="c-table-card__cell u-text-right">
                <Money>{cashSales}</Money>
              </div>
            </div>
          </div>

        </div>
        <hr className="c-separator u-mv" />
        <div className="u-text-center u-mv">
          <button className="c-btn c-btn--red" type="submit">
            Close Register
          </button>
        </div>
      </form>
    </Modal>
  </div>
);
CloseRegister.propTypes = {
  modalOn: PropTypes.func.isRequired,
  modalOff: PropTypes.func.isRequired,
  modalIsOn: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  expectedBalance: PropTypes.number.isRequired,
  actualEndBalance: PropTypes.number.isRequired,
  cashSales: PropTypes.number.isRequired,
  paidOut: PropTypes.number.isRequired,
  openedAt: PropTypes.string.isRequired,
  openedBy: PropTypes.string.isRequired,
  showCountBillsToggle: PropTypes.bool.isRequired,
  countBills: PropTypes.bool,
  paidIn: PropTypes.number.isRequired,
};
CloseRegister.defaultProps = {
  countBills: false,
  actualEndBalance: 0,
};

export default CloseRegister;
